import React from 'react';
import { Layer, Arrow } from 'react-konva';

export const getShapeCenter = (el) => {
  if (!el) return null;
  if (el.type === 'circle') return { x: el.x, y: el.y };
  if (el.type === 'oval') return { x: el.x, y: el.y };
  return {
    x: el.x + (el.width || 120) / 2,
    y: el.y + (el.height || 70) / 2,
  };
};

export const getShapeEdgePoint = (el, targetCenter) => {
  const center = getShapeCenter(el);
  if (!center) return null;
  const dx = targetCenter.x - center.x;
  const dy = targetCenter.y - center.y;
  const angle = Math.atan2(dy, dx);

  if (el.type === 'circle') {
    return {
      x: center.x + Math.cos(angle) * (el.radius || 50),
      y: center.y + Math.sin(angle) * (el.radius || 50),
    };
  }
  if (el.type === 'oval') {
    return {
      x: center.x + Math.cos(angle) * (el.radiusX || 60),
      y: center.y + Math.sin(angle) * (el.radiusY || 35),
    };
  }
  if (el.type === 'triangle' || el.type === 'diamond') {
    return {
      x: center.x + Math.cos(angle) * (el.radius || 50),
      y: center.y + Math.sin(angle) * (el.radius || 50),
    };
  }


  const hw = (el.width || 120) / 2;
  const hh = (el.height || 70) / 2;
  const absDx = Math.abs(dx);
  const absDy = Math.abs(dy);

  if (absDx === 0 && absDy === 0) return center;

  let t;
  if (absDy === 0 || (absDx !== 0 && absDy / absDx < hh / hw)) {
    t = hw / absDx;
  } else {
    t = hh / absDy;
  }

  return {
    x: center.x + dx * t,
    y: center.y + dy * t,
  };
};

const ConnectorLayer = ({ connectors, elements, onRemoveConnector, tool }) => {
  return (
    <Layer>
      {connectors.map((conn) => {
        const fromEl = elements.find((e) => e.id === conn.fromId);
        const toEl = elements.find((e) => e.id === conn.toId);
        if (!fromEl || !toEl) return null;

        const toCenter = getShapeCenter(toEl);
        const fromCenter = getShapeCenter(fromEl);
        if (!toCenter || !fromCenter) return null;

        const start = getShapeEdgePoint(fromEl, toCenter) || fromCenter;
        const end = getShapeEdgePoint(toEl, fromCenter) || toCenter;

        return (
          <Arrow
            key={conn.id}
            points={[start.x, start.y, end.x, end.y]}
            stroke="#64748b"
            fill="#64748b"
            strokeWidth={2}
            pointerLength={10}
            pointerWidth={8}
            lineCap="round"
            lineJoin="round"
            onClick={(e) => {
              e.cancelBubble = true;
              if (tool === 'eraser') {
                onRemoveConnector(conn.id);
                return;
              }
              onRemoveConnector(conn.id);
            }}
            onMouseEnter={(e) => {
              const stage = e.target.getStage();
              if (stage) stage.container().style.cursor = 'pointer';
            }}
            onMouseLeave={(e) => {
              const stage = e.target.getStage();
              if (stage) stage.container().style.cursor = '';
            }}
          />
        );
      })}
    </Layer>
  );
};

export default ConnectorLayer;